export const isScriptNode = (node: HTMLScriptElement) => node.tagName === 'SCRIPT';

export const isExternalScript = (node: HTMLScriptElement) => !!node.src && node.src !== '';

export const cloneScriptNode = (node: HTMLScriptElement) => {
  const script = document.createElement('script');
  if (!import.meta.env.DEV) {
    const WEB_COMPONENT = document.querySelector('scayle-checkout') ? 'scayle-checkout' : 'ay-checkout';
    script.text = node.innerHTML.replaceAll(
      'document.getElementById',
      `document.getElementsByTagName('${WEB_COMPONENT}')[0].shadowRoot.getElementById`
    );
  } else {
    script.text = node.innerHTML;
  }

  [...node.attributes].forEach(({ name, value }) => {
    script.setAttribute(name, value);
  });
  return script;
};

export const replaceScriptNode = (node: any) => {
  if (isScriptNode(node) && !isExternalScript(node)) {
    if (node.parentNode) {
      node.parentNode.replaceChild(cloneScriptNode(node), node);
    }
  } else {
    let i = 0;
    const children = node.childNodes;
    while (i < children.length) {
      replaceScriptNode(children[i++]);
    }
  }
  return node;
};

const removeLoaderFromIngridContainer = () => {
  if (!import.meta.env.DEV) {
    const WEB_COMPONENT = document.querySelector('scayle-checkout') ?? document.querySelector('ay-checkout');
    WEB_COMPONENT?.shadowRoot?.querySelector('#ingrid-loader')?.remove();
  }
};

export const setupGeneralJSListeners = (
  setIsDataChanged: (isDataChanged: boolean) => void,
  setIsLoaded: (isLoaded: boolean) => void
) => {
  if (window._sw) {
    window._sw(
      (api: {
        on: (arg0: string, arg1: { (data: any, meta: any): void }) => void;
        suspend: () => void;
        resume: () => void;
      }) => {
        api.on('data_changed', async (data, meta) =>
          setIsDataChanged(meta.shipping_method_changed && !meta.initial_load)
        );
        api.on('loaded', () => {
          removeLoaderFromIngridContainer();
          setIsLoaded(true);
        });
      }
    );
  }
};
